import * as React from 'react'
import { Button } from 'semantic-ui-react'
import Gallery from '../Gallery/Gallery'

const baseSrc = '//res.cloudinary.com/danrx4fes/image/upload/'

const awardsData = [
  {
    src: baseSrc + 'PREMIOS/1-PREMIO.jpg',
    w: 773,
    h: 640,
  },
  {
    src: baseSrc + 'PREMIOS/2-PREMIO.png',
    w: 1654,
    h: 2339,
  },
  {
    // src: baseSrc + 'PREMIOS/3-PREMIO_PDF.pdf',
    src: baseSrc + 'PREMIOS/3-PREMIO.jpg',
    w: 633,
    h: 845,
  },
  {
    src: baseSrc + 'PREMIOS/4-PREMIO.png',
    w: 1877,
    h: 1359,
  },
  {
    // src: baseSrc + 'PREMIOS/5-PREMIO_PDF.pdf',
    src: baseSrc + 'PREMIOS/5-PREMIO.png',
    w: 1700,
    h: 2200,
  },
  {
    // src: baseSrc + 'PREMIOS/6-PREMIO_PDF.pdf',
    src: baseSrc + 'PREMIOS/6-PREMIO.png',
    w: 2417,
    h: 4264,
  },
  {
    // src: baseSrc + 'PREMIOS/7-PREMIO_PDF.pdf',
    src: baseSrc + 'PREMIOS/7-PREMIO.png',
    w: 1654,
    h: 2339,
  },
]

const Awards = () => {
  const [open, setOpen] = React.useState(false)

  return (
    <>
      <Button
        positive
        style={{ marginTop: 33 }}
        onClick={() => {
          setOpen(true)
        }}
      >
        Premiações e Mídias
      </Button>
      <Gallery
        isOpen={open}
        items={awardsData}
        onClose={() => setOpen(false)}
      />
    </>
  )
}

export default Awards
